import { render, staticRenderFns } from "./patientLog.vue?vue&type=template&id=2c1f2f6e&scoped=true&"
import script from "./patientLog.vue?vue&type=script&lang=js&"
export * from "./patientLog.vue?vue&type=script&lang=js&"
import style0 from "./patientLog.vue?vue&type=style&index=0&id=2c1f2f6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f2f6e",
  null
  
)

export default component.exports